import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IDeleteShoppingListTypesFavoriteProductVariables {
  productId: number;
  unitId: number;
}

type IResponse = ICommandResponseSuccess;

const deleteShoppingListTypesFavoriteProduct = ({
  productId,
  unitId
}: IDeleteShoppingListTypesFavoriteProductVariables): Promise<IResponse> =>
  axios.delete(`/shopping-lists/types/FAVORITES/${productId}/${unitId}`);

export const useDeleteShoppingListTypesFavoriteProduct = (
  options?: UseMutationOptions<IResponse, IError, IDeleteShoppingListTypesFavoriteProductVariables>
) =>
  useMutation(
    (variables: IDeleteShoppingListTypesFavoriteProductVariables) =>
      deleteShoppingListTypesFavoriteProduct(variables),
    options
  );
